import React, { createContext, useContext, useState, useCallback } from 'react'

interface ConsentContextType {
  hasConsented: boolean | null
  acceptCookies: () => void
  rejectCookies: () => void
}

const ConsentContext = createContext<ConsentContextType | undefined>(undefined)

export function ConsentProvider({ children }: { children: React.ReactNode }) {
  const [hasConsented, setHasConsented] = useState<boolean | null>(() => {
    const stored = localStorage.getItem('lgpd-consent')
    return stored === 'true' ? true : stored === 'false' ? false : null
  })

  const acceptCookies = useCallback(() => {
    setHasConsented(true)
    localStorage.setItem('lgpd-consent', 'true')
  }, [])

  const rejectCookies = useCallback(() => {
    setHasConsented(false)
    localStorage.setItem('lgpd-consent', 'false')
  }, [])

  return (
    <ConsentContext.Provider value={{ hasConsented, acceptCookies, rejectCookies }}>
      {children}
    </ConsentContext.Provider>
  )
}

export function useConsent() {
  const context = useContext(ConsentContext)
  if (!context) {
    throw new Error('useConsent must be used within ConsentProvider')
  }
  return context
}